import React from 'react';
import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';
import { Link } from 'react-router-dom';
import {
  C,
  openModalForm,
  selectServicesKapp,
} from '@kineticdata/bundle-common';

const FooterComponent = props => (
  <>
    {/*<img src={logo} alt="Logo" />*/}
    <ul className="footer-links">
      <li>
        <Link to="/">Home</Link>
      </li>
      <li>
        <button className="btn btn-text" onClick={props.openHelpForm}>
          Get Help
        </button>
      </li>
      <li>
        <button className="btn btn-text" onClick={props.openFeedbackForm}>
          Give Feedback
        </button>
      </li>
      <li>
        <a
          href="https://public.govdelivery.com/accounts/USDAOCIO/subscriber/new"
          className="footer-link"
          target="_blank"
          rel="noopener noreferrer"
          role="button"
        >
          Sign up for Email Notification
        </a>
      </li>
      <li>
        <span>1-888-873-6482 (24x7 Service Desk)</span>
      </li>
      <li>
        <a
          href="mailto:DISC.ServiceDesk@usda.gov"
          className="footer-link"
          role="button"
        >
          Email DISC Service Desk
        </a>
      </li>
    </ul>
  </>
);

export const Footer = compose(
  connect(state => ({
    authenticated: state.app.authenticated,
    authRoute: state.app.authRoute,
    servicesKapp: selectServicesKapp(state),
  })),
  withHandlers({
    openHelpForm: props => () =>
      openModalForm({
        ...C.HELP_FORM_CONFIG,
        kappSlug: props.servicesKapp && props.servicesKapp.slug,
      }),
    openFeedbackForm: props => () =>
      openModalForm({
        ...C.FEEDBACK_FORM_CONFIG,
        kappSlug: props.servicesKapp && props.servicesKapp.slug,
      }),
  }),
)(FooterComponent);
